import { useEffect, useState } from "react";
import useTransportOrderService from "../../../app/services/hooks/useTransportOrderService";
import { TransportOrderFilters } from "../../../app/models/TransportOrder";
import { ServiceResponse } from "../../../app/services/shared/interfaces";
import { toast } from "react-toastify";
import { formatMoney } from "../../../utils/utils";
import useExpenseService from "../../../app/services/hooks/useExpenseService";
import { ExpenseDataForm, ExpenseFilters } from "../../../app/models/Expense";
import useTollExpenseService from "../../../app/services/hooks/useExpenseTollService";
import { TollExpenseFilters } from "../../../app/models/TollExpense";
import CommissionsDataTable from "./tables/CommissionsDataTable";
import ExpensesByWorkerDataTable from "./tables/ExpensesByWorkerDataTable";
import TollExpensesByWorkerDataTable from "./tables/TollExpensesByWorkerDataTable";


interface Props {
    transportOrderFilter: TransportOrderFilters;
    setTransportOrderFilter: (transportOrderFilter: TransportOrderFilters) => void;
    setCommissionTotal: (total: number) => void;
    commissionTotal: number;
    searchAction: boolean
}

const CommissionsContainer = ({ 
    transportOrderFilter, 
    setTransportOrderFilter,
    setCommissionTotal,
    commissionTotal,
    searchAction
}: Props) => {

       // COMISIONES
    const {
        getCommissionsInfoByWorker, 
        getCommissionsSumByWorker, 
        fetchingGetCommissionsInfoByWorker, 
        fetchingGetCommissionsSumByWorker 
    } = useTransportOrderService();
    
    const [transportOrders, setTransportOrders] = useState<any[]>([]);
    const [transportOrderRows, setTransportOrderRows] = useState(0);
    const [transportOrderShowDataTable, setTransportOrderShowDataTable] = useState<boolean>(false);

    useEffect(()=>{
        if(transportOrderShowDataTable){
            getCommissionsInfoByWorker(transportOrderFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setTransportOrders(response.data.transport_order)
                    setTransportOrderRows(response.data.total_rows)
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })
        }
    }, [ transportOrderFilter, 
        transportOrderShowDataTable, 
        transportOrderFilter.page, 
        transportOrderFilter.per_page
    ]);

    useEffect(()=>{

        if(transportOrderFilter.worker_id){
            getCommissionsSumByWorker(transportOrderFilter, {
                onSuccess: (response: ServiceResponse) => {
                    setCommissionTotal(response.data.total_commissions)
                },
                onError: (response: ServiceResponse) => {
                    toast.error(response.message);
                }
            })

        }

    },[searchAction]);


    const showCommissionTable = () => {
        setTransportOrderShowDataTable(!transportOrderShowDataTable)
    }

    

   
    

    return (
        <>

                <div className="col-lg-3">
                    <div
                        className="mini-stats-wid card p-2 icon-pointer"
                        style={{
                            backgroundColor: '#BCCAB9',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                        }}
                        onClick={showCommissionTable}
                    >
                        <div className="d-flex">
                            <div className="flex-grow-1">
                                <p className="fw-medium " style={{ userSelect: 'none' }}>Comisiones</p>
                                {fetchingGetCommissionsSumByWorker ? (
                                    <h5 className="mb-0">...</h5>
                                ) : (
                                    <h5 className="mb-0" style={{ userSelect: 'none' }}>{formatMoney(commissionTotal)}</h5>
                                )}
                            </div>
                        </div>
                    </div>
                </div>  


                {transportOrderShowDataTable &&                
                    <div className="col-lg-10 mb-4">
                        <div className="h5">Detalle Ordenes de Transporte</div>
                        <CommissionsDataTable 
                            data={transportOrders}
                            progressPending={fetchingGetCommissionsInfoByWorker}
                            totalRows={transportOrderRows}
                            filter={transportOrderFilter}
                            setFilter={setTransportOrderFilter}
                        />
                    </div>
                }  

        </>
    )

}

export default CommissionsContainer;